import{slice as o}from"../data/slice.js";import{hashFunction as t,hashAbiItem as r}from"./hashFunction.js";const s=s=>o("string"==typeof s?t(s):r(s),0,4);export{s as getFunctionSelector};
